import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { IContractStatusVerifier } from 'src/app/domain/registration/interfaces/contract-type.interface';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { API_PATH } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class PartnerContractStatusService implements IContractStatusVerifier {
    constructor(
        private http: HttpClient,
        private toastService: ToastService
    ) { }

    async hasActiveContract(
        partnerId: string,
        contractType: string
    ): Promise<{ hasContract: boolean; status?: string; contractId?: string }> {
        try {
            if (!partnerId) {
                return { hasContract: false };
            }

            const contracts = await firstValueFrom(
                this.http.get<any[]>(`${API_PATH}contracts/partner/${partnerId}`)
            );

            const contractsOfType = contracts.filter(
                (contract) => contract.contractType === contractType
            );

            if (!contractsOfType || contractsOfType.length === 0) {
                return { hasContract: false };
            }

            const signedContract = contractsOfType.find(
                (contract) => contract.status === 'signed'
            );

            if (signedContract) {
                return {
                    hasContract: true,
                    status: signedContract.status,
                    contractId: signedContract.id,
                };
            }

            const latestContract = contractsOfType.sort(
                (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
            )[0];

            return {
                hasContract: false,
                status: latestContract.status,
                contractId: latestContract.id,
            };
        } catch (error) {
            console.error('Erro ao verificar status do contrato:', error);
            return { hasContract: false };
        }
    }
} 